module.exports = __webpack_public_path__ + "static/media/Lotus.662901ab.png";